import {
  IsBoolean, IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  Length
} from 'class-validator';
import { InvoiceStatusEnum } from '../../enum';

export class InvoiceBillingPatchDto {
  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  invoiceName: string;

  @IsOptional()
  @IsEnum(InvoiceStatusEnum, {message: `Invoice status must be one of the following values: ${Object.values(InvoiceStatusEnum).join(', ')}`,})
  invoiceStatus: InvoiceStatusEnum;

  @IsOptional()
  @IsBoolean()
  queueForDispatch?: boolean;
}